(() => {
  function initializeNav(nav) {
    if (nav.dataset.initialized) return;
    nav.dataset.initialized = 'true';
    const tabs = nav.querySelector('[data-j4u-category-tabs]');
    const triggers = [...nav.querySelectorAll('.j4u-category-button')];
    const close = (returnFocus = false) => {
      for (const button of triggers) {
        if (button.getAttribute('aria-expanded') === 'true') {
          button.setAttribute('aria-expanded', 'false');
          document.getElementById(button.getAttribute('aria-controls')).hidden = true;
          if (returnFocus) button.focus();
        }
      }
    };
    nav.addEventListener('click', event => {
      const trigger = event.target.closest('.j4u-category-button');
      if (trigger) {
        const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
        close();
        if (shouldOpen) {
          trigger.setAttribute('aria-expanded', 'true');
          document.getElementById(trigger.getAttribute('aria-controls')).hidden = false;
        }
      }
      if (event.target.closest('.j4u-panel-close')) close(true);
    });
    nav.addEventListener('keydown', event => {
      if (event.key === 'Escape') close(true);
    });
    document.addEventListener('click', event => { if (!nav.contains(event.target)) close(); });
    const scrollers = [...nav.querySelectorAll('[data-j4u-scroll]')];
    const updateScroll = () => {
      const overflow = tabs.scrollWidth > tabs.clientWidth + 2;
      scrollers.forEach(button => {
        button.hidden = !overflow;
        button.disabled = Number(button.dataset.j4uScroll) < 0
          ? tabs.scrollLeft <= 1
          : tabs.scrollLeft + tabs.clientWidth >= tabs.scrollWidth - 2;
      });
    };
    scrollers.forEach(button => button.addEventListener('click', () => {
      tabs.scrollBy({ left: Number(button.dataset.j4uScroll) * tabs.clientWidth * 0.75,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }));
    tabs.addEventListener('scroll', updateScroll, { passive: true });
    new ResizeObserver(updateScroll).observe(tabs);
    updateScroll();
  }
  const initialize = () => document.querySelectorAll('[data-j4u-nav]').forEach(initializeNav);
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
